<template>
    <div>
        <div class="columns is-mobile">
            <div class="column">
                <p class="title has-text-left">Experimental Data</p>
            </div>
        </div>
        <div class="tile is-ancestor">
            <div class="tile is-12 is-vertical is-parent">
                <div class="tile is-child box has-text-left">
                    <div class="columns">
                        <div class="column is-one-quarter"><strong>Dataset Name:</strong></div>
                        <div class="column">{{experimentalDataset.name}}</div>
                    </div>

                    <div class="columns">
                        <div class="column is-one-quarter"><strong>Assessment Method:</strong></div>
                        <div class="column">{{assessmentMethod.name}}</div>

                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-checkbox v-model="forceToZero" @input="saveForceToZero()">
                                Force linear regresssion to zero when intercept is small ({{'<'}} 2 x intercept SD)
                            </b-checkbox>
                        </div>
                    </div>
                </div>

                <div class="tile is-child box">
                    <div class="columns is-mobile">
                        <div class="column">
                            <!-- Start Dropdown search -->
                            <div v-if="analyteShortNameArray[0]">
                                <p class="is-size-5 title has-text-left">The data is displayed by analyte</p> 
                                <b-field 
                                    label="Select an analyte to view its results">
                                    <b-select v-model="analyteSelected" placeholder="Select an analyte" class="is-uppercase" expanded>
                                        <option
                                            v-for="analyte in analyteObjectArray"
                                            :value="analyte.short_name"
                                            :key="analyte.id">
                                            {{analyte.short_name.toUpperCase()}} ({{ analyte.abbreviation }})
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                            <!-- Loading Data... -->
                            <div v-else>
                                <b-table
                                :loading=true>

                                </b-table>

                                <p class="is-size-5 has-text-centered">Loading data....</p>
                            </div>
                            <!-- End Dropdown search -->
                        </div>
                    </div>
                    
                    <!-- Image end -->
                    <!-- Reuse as component -->
                    <div v-if="experimentalDataImage[0] && analyteShortNameArray[0]" style="margin-top:30px">
                        <!-- selecting Analyte name and abbr -->
                        <p class="is-size-5 title">
                            <span class="is-uppercase" v-if="analyteSelected!=null">{{analyteSelected}}</span>
                            <span class="is-uppercase" v-else-if="currentAnalyte=='NONE'">{{currentAnalyte}}</span>   
                            <span class="is-uppercase" v-else>{{currentAnalyte.short_name}}</span>   
                        </p>
                        <!-- /selecting Analyte name and abbr -->

                        <div class='has-background-white-ter box column is-full' v-for="dataImage in filterImageData" :key="dataImage.value"> 
                            <div class='card equal-height'>
                                <div class='card-content is-flex is-horizontal-center has-background-white-ter'>
                                <figure class='image'><img :src='dataImage.value'></figure>
                                </div>
                            </div>
                            

                            <section class="has-text-left has-background-white-ter" style="padding-top:20px" v-if="!(analyteSelected=='NONE' || currentAnalyte=='NONE') && assessmentMethod.validation_parameter_display=='LoD and LoQ'">
                                <div class="columns" v-if="assessmentMethod.name=='Provide S/N data and/or upload chromatogram(s)'">
                                    <div class="column">
                                        <b-field label="Expected Concentration">
                                            <b-input placeholder="Expected Concentration" :ref="'ref'+dataImage.id"></b-input>
                                        </b-field>
                                        <!-- Current Expected Concentration -->
                                        <div v-if="userInputData.find(item=>item.row==dataImage.index && item.parallel==dataImage.parallel)">
                                            <span>Current value:</span>
                                            <strong class="is-uppercase">
                                                {{userInputData.find(item=>item.row==dataImage.index && item.parallel==dataImage.parallel)['Expected conc.']['rounded_value']}}
                                            </strong>
                                        </div>
                                        <!-- Current Expected Concentration -->
                                        <a class="button is-primary" @click="saveExpectedConcentration(dataImage)">Save</a>
                                    </div>
                                    <div class="column">
                                        <b-field label="S/N">
                                            <b-input placeholder="S/N" :ref="'ref'+dataImage.id+'sn'"></b-input>
                                        </b-field>
                                        <!-- Current S/N -->
                                        <div v-if="userInputData.find(item=>item.row==dataImage.index && item.parallel==dataImage.parallel)">
                                            <span>Current value:</span>
                                            <strong class="is-uppercase">
                                                {{userInputData.find(item=>item.row==dataImage.index && item.parallel==dataImage.parallel)['S/N']['rounded_value']}}
                                            </strong>
                                        </div>
                                        <!-- Current S/N -->                                   
                                        <a class="button is-primary" @click="saveSn(dataImage)">Save</a>
                                    </div>
                                </div> 

                                <div class="columns column" v-if='assessmentMethod.name=="Upload chromatogram(s) for visual evaluation"'>
                                    <div class="column">
                                        <b-field>
                                            <b-input placeholder="Expected Concentration" :ref="'ref'+dataImage.id"></b-input>
                                        </b-field>
                                        <!-- Current Expected Concentration -->
                                        <div v-if="userInputData.find(item=>item.row==dataImage.index && item.parallel==dataImage.parallel)">
                                            <span>Current value:</span>
                                            <strong class="is-uppercase">
                                                {{userInputData.find(item=>item.row==dataImage.index && item.parallel==dataImage.parallel)['Expected conc.']['rounded_value']}}
                                            </strong>
                                        </div>
                                        <!-- Current Expected Concentration -->
                                    </div>
                                    <div class="column">
                                        <a class="button is-primary" @click="saveExpectedConcentration(dataImage)">Save</a>
                                    </div>
                                </div> 
                                
                                <div class="column">
                                    <b-radio v-model="lod_radio"
                                        :native-value="dataImage">
                                        Limit of Detection
                                    </b-radio>
                                    <b-radio v-model="loq_radio"
                                        :native-value="dataImage">
                                        Limit of Quantitation
                                    </b-radio>
                                </div>
                            </section>
                            <hr>
                        </div>

                        <section class="has-text-left box has-background-white-ter" style="padding-top:20px" v-if="!(analyteSelected=='NONE' || currentAnalyte=='NONE') && assessmentMethod.validation_parameter_display=='LoD and LoQ'">
                            <div v-if="lod_radio != '' && loq_radio != ''">
                                <p class="subtitle">
                                    Save your chosen LOD and LOQ values:
                                </p>
                                <div class="columns box column">
                                    <div class="column">
                                        <span>LOD: {{userInputValue(lod_radio)}}</span>
                                    </div>
                                    <div class="column">
                                        <span>LOQ: {{userInputValue(loq_radio)}}</span>
                                    </div>
                                    <div class="column">
                                        <a class="button is-primary"  @click="saveLodLoqValues()">Save</a>
                                    </div>
                                </div>
                            </div>
                            <span v-else>Select your LOD and LOQ values above</span>
                        </section>

                        <div v-if="!filterImageData[0]">
                            No Data for this Analyte
                        </div>
                    </div>
                    <!-- Image end -->

                    <div v-if="currentAnalyte!='' && !experimentalDataImage[0]"> 
                        <p class="is-size-5 title">
                            <span class="is-uppercase" v-if="analyteSelected!=null">{{analyteSelected}}</span>
                            <span class="is-uppercase" v-else>{{currentAnalyte}}</span>   
                        </p>
                        <hr>
                        <div v-if="assessmentMethod.name.includes('CCα and CCβ')" class="has-text-left is-mobile">
                            <div class="columns">
                                <div class="column">
                                    <b-field label="Alfa*, Beta*">
                                        <b-input v-model="alfaValue"></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="K*">
                                        <b-input v-model="kValue"></b-input>
                                    </b-field>
                                </div>
                            </div>      
                            <div class="has-text-right">
                                <a class="button is-primary" @click="saveAlfaBetaK()">
                                    <span>Save</span>
                                </a>
                            </div>
                        </div>
                        <hr>
                        <b-tabs type="is-boxed" v-model="activeTab" expanded v-if="seriesArray.length>1"> <!-- more than one series -->
                            <b-tab-item :label="'Series '+series" v-for="series in seriesArray" :key="series" v-if="filterExperimentalData.filter(dataValue => dataValue.series == series).length>0">
                                <b-table
                                    :data="isEmpty ? [] : filterExperimentalData.filter(dataValue => dataValue.series == series)"
                                    :bordered="isBordered"
                                    :striped="false"
                                    :narrowed="isNarrowed"
                                    :hoverable="isHoverable"
                                    :loading="isLoading"
                                    :focusable="isFocusable"
                                    :mobile-cards="hasMobileCards"
                                    >
                                    
                                    <template slot-scope="props">
                                        <b-table-column v-for="header in headerArray" :key="header"  :field="header" :label="header">
                                            <div v-if="header == 'parallel' || header == 'marker' || header == 'level'">
                                                {{props.row[header]}}
                                            </div>
                                            <b-field v-else>
                                                <b-input :class="props.row[header].status" v-model="props.row[header].rounded_value" v-on:change.native="editCell(props.row[header])"></b-input>
                                            </b-field>
                                        </b-table-column>
                                    </template>     
                                    <template slot="empty">
                                        <div class="has-text-centered column">
                                            <p>No data for this series..</p>
                                        </div> 
                                    </template>                  
                                </b-table>
                            </b-tab-item>
                        </b-tabs>

                        <div v-else>  <!-- only one series -->
                            <b-table
                                :data="isEmpty ? [] : filterExperimentalData"
                                :bordered="isBordered"
                                :striped="false"
                                :narrowed="isNarrowed"
                                :hoverable="isHoverable"
                                :loading="isLoading"
                                :focusable="isFocusable"
                                :mobile-cards="hasMobileCards"
                                >
                                
                                <template slot-scope="props">
                                    <b-table-column v-if="header!='series' && header!='analyte'" v-for="header in headerArray" :key="header"  :field="header" :label="header">
                                        <div v-if="header == 'analyte' || header == 'series' || header == 'parallel' || header == 'marker' || header == 'level'">
                                            {{props.row[header]}}
                                        </div>

                                        <b-field v-else>
                                            <b-input :class="props.row[header].status" v-model="props.row[header].rounded_value" v-on:change.native="editCell(props.row[header])"></b-input>
                                        </b-field>
                                    </b-table-column>
                                </template>     
                                <template slot="empty">
                                    <div class="has-text-centered column">
                                        <p>No data for this series..</p>
                                    </div> 
                                </template>                  
                            </b-table>
                        </div>
                    </div>                    
                </div>

                <div class="tile is-child">
                    <!-- Action buttons -->
                    <span class="is-pulled-right">
                        <a class="button is-primary is-large" @click="computeResult()">
                            <span>Calculate results</span>
                        </a>
                        <span style="margin-left:20px" v-if="isCalculated"></span>
                        <a class="button is-large" @click="showResult()" v-if="isCalculated">
                            <span>Show results</span>
                        </a>
                        <span style="margin-left:20px"></span>
                        <a class="button is-large" @click="$router.go(-1)">
                            <span>Back</span>
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios"

export default {
    name: "ViewExperimentalDataComponent",
    props: ["currentExperimentalData", "restructuredExperimentalData", "headerArray", "seriesArray", "analyteShortNameArray", "experimentalDataset", "assessmentMethod", "experimentalDataImage", "currentAnalyte", "analyteObjectArray", "userInputData"],
    data: function () {
        return {
            //Dropdown search variables
            analyteName: '',
            analyteSelected: null,
            // tab
            activeTab: 0,
            // Table variables
            filteredExperimentalData:[],
            isEmpty: false,
            isBordered: false,
            isStriped: true,
            isNarrowed: false,
            isHoverable: true,
            isFocusable: true,
            isLoading: false,
            isCalculated: false,
            hasMobileCards: true,
            expectedConcentrationInputs:'',
            lod_radio:'',
            loq_radio:'',
            lod_value:'',
            loq_value:'',
            alfaValue:'',
            kValue:'',
            forceToZero: false
        }
    },
    computed: {
        filteredAnalyteObj() {            
            return this.analyteShortNameArray.filter((option) => {
                return option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.analyteName.toLowerCase()) >= 0
            })
        },
        filterExperimentalData() {
            if(this.analyteSelected != null) {
                return this.restructuredExperimentalData.filter(dataValue => dataValue.analyte.short_name.toUpperCase() == this.analyteSelected.toUpperCase())  
            }
            else {
                return this.restructuredExperimentalData.filter(dataValue => dataValue.analyte.short_name.toUpperCase() == this.currentAnalyte.toUpperCase())
            }
        },
        filterImageData() {
            if(this.analyteSelected != null) {
                if(this.analyteSelected=='NONE'){
                    return this.experimentalDataImage.filter(dataValue => dataValue.analyte == null)
                } else {
                    return this.experimentalDataImage.filter(dataValue => dataValue.analyte != null && dataValue.analyte.value.toUpperCase() == this.analyteSelected.toUpperCase()) 
                }
            }
            else {
                if(this.currentAnalyte=='NONE'){
                    return this.experimentalDataImage.filter(dataValue => dataValue.analyte == null)
                } else {
                    return this.experimentalDataImage.filter(dataValue => dataValue.analyte != null && dataValue.analyte.value.toUpperCase() == this.currentAnalyte.short_name.toUpperCase())
                }
            }
        },
        ...mapGetters ([
            'currentExperimentalDataObject', 'auth_header', 'base_url'
        ])
    },
    mounted(){
        axios
        .get(
            this.base_url+ 'experiments/datasets/' +
            this.currentExperimentalDataObject.experimental_dataset_id +
            '/assessments/' +
            this.currentExperimentalDataObject.assesment_method_id +
            '/force_to_zero/'
        ).then(response => {
            this.forceToZero = response.data
        });
    },
    methods: {
        saveForceToZero(){
            axios
              .put(
                  this.base_url+ 'experiments/datasets/' +
                  this.currentExperimentalDataObject.experimental_dataset_id +
                  '/assessments/' +
                  this.currentExperimentalDataObject.assesment_method_id +
                  '/force_to_zero/',
                  {
                      headers: this.auth_header,
                      value: this.forceToZero
                  }
              );
        },
        editCell: function(dataCell) {
            delete dataCell.status
            dataCell.value = dataCell.rounded_value
            this.$emit("editCell", dataCell)
            this.requiresValidation()
        },
        userInputValue: function(dataImage) {
            // console.log("dataImage ref", this.$refs['ref'+dataImage.id][0])
            return this.$refs['ref'+dataImage.id][0].newValue
        },
        saveAlfaBetaK: function(){
            if(this.alfaValue=='' || this.kValue==''){
                this.$toast.open({
                    message: `Provide a value for Alfa, Beta and K before saving`,
                    position: 'is-top',
                    type: 'is-danger'
                })
            }
            else {
                var newData ={
                    alfa: this.alfaValue,
                    beta: this.alfaValue,
                    k: this.kValue,
                    analyte: this.analyteSelected || this.currentAnalyte
                }
                this.$emit("saveAlfaBetaK", newData)
            }
        },
        saveSn: function(dataImage, index){
            
            if(this.assessmentMethod.name=='Provide S/N data and/or upload chromatogram(s)' && this.$refs['ref'+dataImage.id][0].newValue+'sn'){
                var newData = {
                    analyte: dataImage.analyte.id,
                    assessment_method: dataImage.assessment_method,
                    experiment_data: {"name": "Signal-to-noise ratio (S/N)", "data_type": "float", "type": 0},
                    experiment_dataset: dataImage.experiment_dataset,
                    level: dataImage.level,
                    marker: dataImage.marker,
                    parallel: dataImage.parallel,
                    row: dataImage.index,
                    series: dataImage.series,
                    status: dataImage.status,
                    value: this.$refs['ref'+dataImage.id+'sn'][0].newValue,
                }             
                this.$emit("saveExpectedConcentration", newData)
                this.requiresValidation()
                
            } else {
                this.$toast.open({
                    message: `Enter a value for S/N`,
                    position: 'is-top',
                    type: 'is-danger'
                })
            }
        },
        saveExpectedConcentration: function(dataImage){
            console.log("data", dataImage)
            if(this.$refs['ref'+dataImage.id][0].newValue){
                var newData = {
                    analyte: dataImage.analyte.id,
                    assessment_method: dataImage.assessment_method,
                    experiment_data: {"name": "expected concentration", "data_type": "float", "type": 0},
                    experiment_dataset: dataImage.experiment_dataset,
                    level: dataImage.level,
                    marker: dataImage.marker,
                    parallel: dataImage.parallel,
                    row: dataImage.index,
                    series: dataImage.series,
                    status: dataImage.status,
                    value: this.userInputValue(dataImage),
                }             
                this.$emit("saveExpectedConcentration", newData)
                this.requiresValidation()
                
            } else {
                this.$toast.open({
                    message: `Enter a value for expected concentration`,
                    position: 'is-top',
                    type: 'is-danger'
                })
            }           
            
        },
        saveLodLoqValues: function(){
            if(this.userInputValue(this.lod_radio) && this.userInputValue(this.loq_radio)){
                var lisOfLoqLod = [this.lod_radio, this.loq_radio]
                var experimentData = ['lod', 'loq']
                // console.log("lisOfLoqLod", lisOfLoqLod)
                lisOfLoqLod.forEach((dataImage, index) => {
                    var newData = {
                        analyte: dataImage.analyte.id,
                        assessment_method: dataImage.assessment_method,
                        experiment_data: {"name": experimentData[index], "data_type": "float", "type": 0},
                        experiment_dataset: dataImage.experiment_dataset,
                        level: dataImage.level,
                        marker: dataImage.marker,
                        parallel: dataImage.parallel,
                        row: null,
                        series: null,
                        status: dataImage.status,
                        value: this.userInputValue(dataImage),
                    }
                    this.$emit("saveExpectedConcentration", newData)                    
                })
                this.$toast.open({
                    message: `Saving LOD and LOQ values`,
                    position: 'is-top',
                    type: 'is-primary'
                })
            }  
            else {
                this.$toast.open({
                    message: `Enter a value for LOD and LOQ before you save`,
                    position: 'is-top',
                    type: 'is-danger'
                })
            }
        },
        computeResult: function() {
            this.$emit("computeResult")
        },
        showResult: function() {
            this.$emit("showResult")
        },
        requiresValidation: function() {
            this.$emit("requiresValidation")
        }
    }
}
</script>

<style>
 .capitalize {
  text-transform: capitalize;
  }

  .invalid {
      border: 2px solid red;
        border-radius: 4px;
  }

   .is-horizontal-center {
    justify-content: center;
    }
  /* TODO classes for status of valid and invalid cell and row */
</style>
